<template>
  <div class="table__result">
    <div class="info__color">
      <ul>
        <li><span style="background: red"></span> - Баланс &lt; 60</li>
        <li>
          <span style="background: orange"></span> - Баланс > 60 и &lt; 200
        </li>
        <li><span style="background: green"></span> - Баланс > 200</li>
      </ul>
    </div>

    <div class="table__header">
      <div class="left">
        <h4>{{ newOrder ? 'Создание заказа' : 'Редактирование заказа' }}</h4>
        <p>Школа: {{ schoolValue.school }}</p>
        <p>Класс: {{ classValue.class }}</p>
        <p>Дата: {{ new Date(date).toLocaleDateString() }}</p>
      </div>
      <div class="right">
        <button @click="$emit('clear')">Очистить заказ</button>
      </div>
    </div>
    <button
      v-if="!newOrder"
      class="btn__refresh_student"
      @click="$emit('refresh')"
    >
      Обновить список учеников
    </button>
    <table class="order__food">
      <thead>
        <tr class="first__row">
          <th rowspan="3">№ПП</th>
          <th rowspan="3">ФИО учащегося/преподавателя</th>
          <th rowspan="3">Льгота</th>
          <th colspan="3" class="color1">Бесплатное питание</th>
          <th colspan="3" class="color2">Платное питание</th>
          <th colspan="3">Льготное питание</th>
          <th colspan="2" class="color3">Льготное питание + доплата</th>
          <th
            colspan="3"
            class="color4"
            v-if="showGpd"
          >
            ГПД
          </th>
        </tr>
        <tr>
          <th class="color1">Завтрак</th>
          <th class="color1">Обед</th>
          <th class="color1">Полдник</th>
          <th class="color2">Завтрак</th>
          <th class="color2">Обед</th>
          <th class="color2">Полдник</th>
          <th class="color5">Завтрак</th>
          <th class="color5">Обед</th>
          <th class="color5">Полдник</th>
          <th class="color3">Завтрак</th>
          <th class="color3">Обед</th>
          <th
            class="color4"
            v-if="showGpd"
          >
            Платное
          </th>
          <th
            class="color4"
            v-if="showGpd"
          >
            Льготника
          </th>
          <th
            class="color4"
            v-if="showGpd"
          >
            Льготника с доплатой
          </th>
        </tr>
        <tr class="last__row">
          <th class="color1">
            <input
              type="checkbox"
              :disabled="!dostup"
              :checked="selectAll.select_all_bp"
              @change="$emit('select-all', 'select_all_bp', $event.target.checked)"
            />
          </th>
          <th class="color1">
            <input
              type="checkbox"
              :disabled="!dostup"
              :checked="selectAll.select_all_bpO"
              @change="$emit('select-all', 'select_all_bpO', $event.target.checked)"
            />
          </th>
          <th class="color1">
            <input
              type="checkbox"
              :disabled="!dostup"
              :checked="selectAll.select_all_bpP"
              @change="$emit('select-all', 'select_all_bpP', $event.target.checked)"
            />
          </th>
          <th class="color2">
            <input
              type="checkbox"
              :disabled="!dostup"
              :checked="selectAll.select_all_pp"
              @change="$emit('select-all', 'select_all_pp', $event.target.checked)"
            />
          </th>
          <th class="color2">
            <input
              type="checkbox"
              :disabled="!dostup"
              :checked="selectAll.select_all_ppO"
              @change="$emit('select-all', 'select_all_ppO', $event.target.checked)"
            />
          </th>
          <th class="color2">
            <input
              type="checkbox"
              :disabled="!dostup"
              :checked="selectAll.select_all_ppP"
              @change="$emit('select-all', 'select_all_ppP', $event.target.checked)"
            />
          </th>
          <th class="color5">
            <input
              type="checkbox"
              :disabled="!dostup"
              :checked="selectAll.select_all_lgZ1_food"
              @change="$emit('select-all', 'select_all_lgZ1_food', $event.target.checked)"
            />
          </th>
          <th class="color5">
            <input
              type="checkbox"
              :disabled="!dostup"
              :checked="selectAll.select_all_lgO1_food"
              @change="$emit('select-all', 'select_all_lgO1_food', $event.target.checked)"
            />
          </th>
          <th class="color5">
            <input
              type="checkbox"
              :disabled="!dostup"
              :checked="selectAll.select_all_lgP1_food"
              @change="$emit('select-all', 'select_all_lgP1_food', $event.target.checked)"
            />
          </th>
          <th class="color3">
            <input
              type="checkbox"
              :disabled="!dostup"
              :checked="selectAll.select_all_lg_zav"
              @change="$emit('select-all', 'select_all_lg_zav', $event.target.checked)"
            />
          </th>
          <th class="color3">
            <input
              type="checkbox"
              :disabled="!dostup"
              :checked="selectAll.select_all_lg_ob"
              @change="$emit('select-all', 'select_all_lg_ob', $event.target.checked)"
            />
          </th>
          <th
            class="color4"
            v-if="showGpd"
          >
            <input
              type="checkbox"
              :checked="selectAll.select_all_lg_gpd"
              @change="$emit('select-all', 'select_all_lg_gpd', $event.target.checked)"
            />
          </th>
          <th
            class="color4"
            v-if="showGpd"
          >
            <input
              type="checkbox"
              :checked="selectAll.select_all_lg_gpdP"
              @change="$emit('select-all', 'select_all_lg_gpdP', $event.target.checked)"
            />
          </th>
          <th
            class="color4"
            v-if="showGpd"
          >
            <input
              type="checkbox"
              :checked="selectAll.select_all_lg_gpdPD"
              @change="$emit('select-all', 'select_all_lg_gpdPD', $event.target.checked)"
            />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in orderFood" :key="item.id">
          <td :style="{ background: getColor(item) }">
            {{ index + 1 }}
          </td>
          <td>{{ item.fio }}</td>
          <td>{{ item.LGOTA === '1' ? item.type_lgota || 'Л' : '' }}</td>
          <td
            class="color1"
          >
            <input
              type="checkbox"
              v-model="item.bp"
              :disabled="!dostup"
              @change="$emit('update-bp-food', item, 'bp')"
            />
          </td>
          <td
            class="color1"
          >
            <input
              type="checkbox"
              v-model="item.bpO"
              :disabled="!dostup"
              @change="$emit('update-bp-food', item, 'bpO')"
            />
          </td>
          <td class="color1">
            <input
              type="checkbox"
              v-model="item.bpP"
              :disabled="!dostup"
              @change="$emit('update-bp-food', item, 'bpP')"
            />
          </td>
          <td class="color2">
            <input
              type="checkbox"
              v-model="item.pp"
              :disabled="checkPp(item.pp, item)"
            />
          </td>
          <td class="color2">
            <input
              type="checkbox"
              v-model="item.ppO"
              :disabled="checkPp(item.ppO, item)"
            />
          </td>
          <td class="color2">
            <input
              type="checkbox"
              v-model="item.ppP"
              :disabled="checkPp(item.ppP, item)"
            />
          </td>
          <td style="text-align: center">
            <input
              type="checkbox"
              v-model="item.lgZ1"
              :disabled="!item.type_lgota"
              @change="$emit('update-lg-food', item, 'lgZ1')"
            />
          </td>
          <td style="text-align: center">
            <input
              type="checkbox"
              v-model="item.lgO1"
              :disabled="!item.type_lgota"
              @change="$emit('update-lg-food', item, 'lgO1')"
            />
          </td>
          <td style="text-align: center">
            <input
              type="checkbox"
              v-model="item.lgP1"
              :disabled="
                item.type_lgota !== 'моб' && item.type_lgota !== 'овз'
              "
              @change="$emit('update-lg-food', item, 'lgP1')"
            />
          </td>
          <td class="color3">
            <input
              type="checkbox"
              v-model="item.lgZ"
              :disabled="checkLg(item.lgZ, item, true)"
              @change="$emit('update-lg-food', item, 'lgZ')"
            />
          </td>
          <td class="color3">
            <input
              type="checkbox"
              v-model="item.lgO"
              :disabled="checkLg(item.lgO, item, true)"
              @change="$emit('update-lg-food', item, 'lgO')"
            />
          </td>
          <td
            class="color4"
            v-if="showGpd"
          >
            <input
              type="checkbox"
              v-model="item.gpd"
              :disabled="checkGpd(item.gpd, item)"
              @change="$emit('update-lg-food', item, 'gpd')"
            />
          </td>
          <td
            class="color4"
            v-if="showGpd"
          >
            <input
              type="checkbox"
              v-model="item.gpdP"
              :disabled="checkGpdP(item.gpdP, item)"
              @change="$emit('update-lg-food', item, 'gpdP')"
            />
          </td>
          <td
            class="color4"
            v-if="showGpd"
          >
            <input
              type="checkbox"
              v-model="item.gpdPD"
              :disabled="checkGpdPD(item.gpdPD, item)"
              @change="$emit('update-lg-food', item, 'gpdPD')"
            />
          </td>
        </tr>
        <tr>
          <th></th>
          <th>Итого:</th>
          <th></th>
          <th>{{ getSumm(1) }}</th>
          <th>{{ getSumm(2) }}</th>
          <th>{{ getSumm(14) }}</th>
          <th>{{ getSumm(3) }}</th>
          <th>{{ getSumm(4) }}</th>
          <th>{{ getSumm(5) }}</th>
          <th>{{ getSumm(6) }}</th>
          <th>{{ getSumm(7) }}</th>
          <th>{{ getSumm(8) }}</th>
          <th>{{ getSumm(9) }}</th>
          <th>{{ getSumm(10) }}</th>
          <th
            v-if="showGpd"
          >
            {{ getSumm(11) }}
          </th>
          <th
            v-if="showGpd"
          >
            {{ getSumm(12) }}
          </th>
          <th
            v-if="showGpd"
          >
            {{ getSumm(13) }}
          </th>
        </tr>
      </tbody>
    </table>
    <button class="order__food_btn" @click="$emit('save')">
      {{ newOrder ? 'Сохранить' : 'Сохранить изменения' }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'OrderFoodTable',
  props: {
    orderFood: {
      type: Array,
      required: true,
    },
    newOrder: {
      type: Boolean,
      default: true,
    },
    date: {
      type: String,
      default: '',
    },
    schoolValue: {
      type: Object,
      default: null,
    },
    classValue: {
      type: Object,
      default: null,
    },
    selo: {
      type: Boolean,
      default: false,
    },
    dostup: {
      type: Boolean,
      default: false,
    },
    selectAll: {
      type: Object,
      default: () => ({}),
    },
    checkPp: {
      type: Function,
      required: true,
    },
    checkGpd: {
      type: Function,
      required: true,
    },
    checkGpdP: {
      type: Function,
      required: true,
    },
    checkGpdPD: {
      type: Function,
      required: true,
    },
    checkLg: {
      type: Function,
      required: true,
    },
    getColor: {
      type: Function,
      required: true,
    },
    getSumm: {
      type: Function,
      required: true,
    },
  },
  computed: {
    showGpd() {
      if (!this.classValue) return false;
      return (
        !this.selo &&
        Number(this.classValue.class.toString().replace(/[^0-9]/g, '')) <= 4
      );
    },
  },
};
</script>
